import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { leaveGuardedRouteOnLogout } from '@core/guards/auth.guard';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `<router-outlet />`,
})
export class App {
  constructor() {
    leaveGuardedRouteOnLogout();
  }
}
